/* eslint-disable camelcase */
import { omit, compact } from 'lodash-es'
import queryString from 'query-string'
import { sortObject } from './object'

export const constructSearchUrl = ({ currentLocation = window.location.href, toSlug = 'search', queryParams }) => {
  const parsedCurrentLocation =
    typeof currentLocation === 'object'
      ? currentLocation
      : queryString.parseUrl(currentLocation, { arrayFormat: 'index' }).query

  // TODO: dunno how to fix this thing...
  if (parsedCurrentLocation.postedBy) {
    parsedCurrentLocation.posted_by = parsedCurrentLocation.postedBy
    delete parsedCurrentLocation.postedBy
  }

  if (parsedCurrentLocation.timeRange) {
    parsedCurrentLocation.time_range = parsedCurrentLocation.timeRange
    delete parsedCurrentLocation.timeRange
  }

  const parsedQueryParams =
    typeof queryParams === 'object' ? queryParams : queryString.parse(queryParams, { arrayFormat: 'index' })

  return `/${toSlug}?${queryString.stringify(
    omit(
      sortObject({
        ...parsedCurrentLocation,
        ...parsedQueryParams,
        ...(parsedCurrentLocation.flag === 'fromTheEditor' && !queryParams.postedBy && { postedBy: 'guidehuman' }),
        ...(parsedCurrentLocation.flag === 'popularPicks' && !queryParams.type && { type: 'picks' })
      }),
      compact([
        ...Object.entries(parsedQueryParams).map(
          ([key, value]) => parsedCurrentLocation[key] === parsedQueryParams[key] && key
        ),
        ...[toSlug === 'search' && 'flag']
      ])
    ),
    { arrayFormat: 'index' }
  )}`
}

export function getLastWord(words) {
  if (words) {
    const n = words.split(' ')
    return n[n.length - 1]
  } else {
    return null
  }
}

export const getBEMClasses = (base, mods) =>
  base && mods ? (Array.isArray(mods) ? mods : [mods]).reduce((a, v) => (v ? `${a} ${base}--${v}` : a), base) : base

export const getFullName = ({ full_name, first_name, last_name }) =>
  full_name || (first_name && last_name ? `${first_name} ${last_name}` : '')

function extractHostname(url) {
  var hostname
  // find & remove protocol (http, ftp, etc.) and get hostname

  if (url.indexOf('://') > -1) {
    hostname = url.split('/')[2]
  } else {
    hostname = url.split('/')[0]
  }

  // find & remove port number
  hostname = hostname.split(':')[0]
  // find & remove "?"
  hostname = hostname.split('?')[0]

  return hostname
}

export const extractRootDomain = url => {
  let domain = extractHostname(url)
  let splitArr = domain.split('.')
  let arrLen = splitArr.length

  // extracting the root domain here
  // if there is a subdomain
  if (arrLen > 2) {
    domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1]
    // check to see if it's using a Country Code Top Level Domain (ccTLD) (i.e. ".me.uk")
    if (splitArr[arrLen - 2].length === 2 && splitArr[arrLen - 1].length === 2) {
      // this is using a ccTLD
      domain = splitArr[arrLen - 3] + '.' + domain
    }
  }
  return domain
}
